import { GeometryType, Layer } from 'interfaces/maps.interface';
import { PLACE_SOURCE_TYPES } from 'utils/constants';

const deriveSelectedLayerGeometryType = (selectedLayer: Layer) => {
	let geometryType: GeometryType = 'POLYGON';
	if (
		[
			PLACE_SOURCE_TYPES.PIPE_INSTALLATION_SRC,
			PLACE_SOURCE_TYPES.INSIDE_BUND_SRC,
			PLACE_SOURCE_TYPES.AWD_SOUTH_2021,
			PLACE_SOURCE_TYPES.IOT_GATEWAY_TYPE,
		].includes(selectedLayer?.PlaceSourceType)
	) {
		geometryType = 'POINT';
	}
	return geometryType;
};

export default deriveSelectedLayerGeometryType;
